import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
  title: Yup.string().trim().required("Title is required.").max(100, "Title must be at most 100 characters."),
  description: Yup.string()
    .trim()
    .required("Description is required.")
    .min(100, "Description must be at least 100 characters.")
    .max(4000, "Description must be at most 4000 characters."),

  // At least one attachment is required.
  attachments: Yup.array().min(1, "At least one attachment is required."),
});
